import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

interface Props {
    name: string;
}

const ElectionYear = (props: Props) => {
    return <div className="mb-[0.5rem] font-bold hidden lg:block">{props.name}</div>;
};

const ElectionYearWithStore = () => {
    const { generalSettingsStore } = getStore();
    const { selectedElectionData } = generalSettingsStore;

    return <ElectionYear name={selectedElectionData?.name || ''} />;
};

export default observer(ElectionYearWithStore);
